import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=ce0d5804&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=ce0d5804&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0d5804",
  null
  
)

export default component.exports